import { AsyncPortal } from "@circle-react-uikit/AsyncPortal";

import { STANDARD_LAYOUT_V2_COVER_IMAGE_CONTAINER as id } from "@/react/components/constants";
import { CoverImage } from "@/react/components/Layout/StandardLayoutV2/CoverImage";

export interface MobileCoverImageProps {
  coverImageUrl: string;
  thumbnailImageUrl?: string;
}

export const MobileCoverImage = ({
  thumbnailImageUrl,
  coverImageUrl,
}: MobileCoverImageProps) => {
  const url = thumbnailImageUrl || coverImageUrl;
  const isThumbnail = !!thumbnailImageUrl;
  return (
    <AsyncPortal selectorQuery={`#${id}`}>
      <CoverImage url={url} thumbnail={isThumbnail} />
    </AsyncPortal>
  );
};
